import { Card, Spin, Table } from 'antd';
import React from 'react';

interface RecipeTableProps {
  recipeData: any | null;
  loading: boolean;
  expenseData?: any;
  wastageData?: any;
}

const RecipeTable: React.FC<RecipeTableProps> = ({
  recipeData,
  loading,
  expenseData,
  wastageData,
}) => {
  const columns = [
    { title: 'Used Variant Name', dataIndex: 'usedVariantName', key: 'usedVariantName' },
    { title: 'Used Variant SKU', dataIndex: 'usedVariantSku', key: 'usedVariantSku' },
    { title: 'Inventory Quantity', dataIndex: 'inventoryQuantity', key: 'inventoryQuantity' },
    { title: 'Notes', dataIndex: 'note', key: 'note' },
    {
      title: 'Used Product Quantity',
      dataIndex: 'usedProductQuantity',
      key: 'usedProductQuantity',
    },
    { title: 'Used Product Cost', dataIndex: 'usedProductCost', key: 'usedProductCost' },
    { title: 'Availability', dataIndex: 'availability', key: 'availability' },
  ];

  // Calculate costs
  const materialCost =
    recipeData?.usedProductRecipes?.reduce(
      (sum: number, item: any) => sum + (item.usedProductCost || 0),
      0
    ) || 0;

  const wastageCost =
    wastageData?.reduce((sum: number, item: any) => sum + Number(item.cost || 0), 0) || 0;

  const expenseCost =
    expenseData?.reduce((sum: number, item: any) => sum + Number(item.amount || 0), 0) || 0;

  const totalManufacturingCost = materialCost + wastageCost + expenseCost;

  return (
    <Card title="Recipe Details">
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="large" />
          <p>Loading recipe details...</p>
        </div>
      ) : (
        <>
          {recipeData && recipeData.madeUpVariantName ? (
            <>
              <p>
                <strong>Product Name:</strong> {recipeData.madeUpVariantName} (
                {recipeData.madeUpVariantSku})
              </p>
              <p>
                <strong>Default Purchase Price:</strong> {recipeData.purchasePrice}
              </p>
              <p>
                <strong>Default Selling Price:</strong> {recipeData.sellingPrice}
              </p>
              <p>
                <strong>Material Cost:</strong> {materialCost}
              </p>
              <p>
                <strong>Wastage:</strong> {wastageCost}
              </p>
              <p>
                <strong>Expense:</strong> {expenseCost}
              </p>
              <p>
                <strong>Total Manufacturing Cost:</strong> {totalManufacturingCost}
              </p>
            </>
          ) : (
            <p>
              <strong>No product details available</strong>
            </p>
          )}

          <Table
            dataSource={recipeData?.usedProductRecipes || []}
            columns={columns}
            rowKey="usedVariantId"
            pagination={false}
            bordered
            scroll={{ x: 'max-content' }}
          />
        </>
      )}
    </Card>
  );
};

export default RecipeTable;
